import { restClient } from 'libs/restClient';
import { FETCH_AUTHORIZED_LABS } from 'actions/types';

export function fetchAuthorizedLabs() {
  const url = '/companies/labs?page=0&orderBy=name ASC';
  const payload = restClient
    .get(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: FETCH_AUTHORIZED_LABS,
    payload
  };
}



// WEBPACK FOOTER //
// ./src/actions/labs.js